'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _types = require('../types');

var initialState = exports.initialState = {
  blocked: false,
  botProjectId: '',
  chatInProgressElsewhere: false,
  dialogFlow: {},
  scrolled: true
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case _types.APP_BLOCKED_SET:
      {
        return _extends({}, state, {
          blocked: action.payload
        });
      }

    case _types.APP_CHAT_IN_PROGRESS_ELSEWHERE:
      {
        return _extends({}, state, {
          chatInProgressElsewhere: action.payload
        });
      }

    case _types.APP_SCROLLED_SET:
      {
        return _extends({}, state, {
          scrolled: action.payload
        });
      }

    case _types.APP_BOT_PROJECT_ID_SET:
      {
        return _extends({}, state, {
          botProjectId: action.payload
        });
      }

    case _types.APP_DIALOGFLOW_SET:
      {
        return _extends({}, state, {
          dialogFlow: _extends({}, state.dialogFlow, action.payload)
        });
      }

    default:
      {
        return state;
      }
  }
};